export default __webpack_public_path__ + "static/media/offbeat-spanish-english.b27eb0c1.webp";